/**
 * External dependencies
 */

import React from 'react';

/**
 * DWT dependencies
 */

import { closeButtonIcon } from '../../img/icons';
import { capitalizeFirstLetter } from '../../blocks/utils/general-utils';
import BookModalMain from '../Books/BookModalMain';
import ContributorModalMain from '../Contributors/ContributorModalMain';
import ShareModalMain from './ShareModalMain';

/**
 * DWTPlaceholder
 *
 * A DWT reusable component
 *
 * @param {Object}  props
 * @param {string}  props.context
 * @param {string}  props.modalClass
 * @param {Object}  props.modalData
 * @param {string}  props.modalType
 * @param {Object}  props.onClose
 */

const Modal = React.forwardRef(
  ({ context, modalClass, modalData, modalType, onClose }, modalRef ) => {
    return (
      <div
        className={`modal ${modalClass}`}
        data-modal={
          context.featureBy === 'books' ? 'books' : 'contributors'
        }
        role="dialog"
        aria-label={`${capitalizeFirstLetter( modalType || '' )} Modal`}
        aria-modal="true"
        ref={modalRef}
      >
        <div className="modal__header self-end">
          <button
            type="button"
            className="modal__btn--close cursor-pointer"
            aria-label="Close modal"
            onClick={onClose}
          >
            {closeButtonIcon}
          </button>
        </div>

        {modalType === 'share' && (
          <ShareModalMain
            modalData={modalData}
            context={context}
            onClose={onClose}
          />
        )}

        {modalType === 'books' && (
          <BookModalMain
            modalData={modalData}
            context={context}
            onClose={onClose}
          />
        )}

        {modalType === 'contributors' && (
          <ContributorModalMain
            modalData={modalData}
            context={context}
            onClose={onClose}
          />
        )}
      </div>
    );
  }
);

export default Modal;
